import { ReactNode } from "react";

export default function ApplicationSectionHeader({
  title,
  actions,
}: {
  title: string;
  actions?: ReactNode;
}) {
  return (
    <div className="sticky top-0 z-10 bg-background border-b border-border/30 -mx-24 px-24 py-3 mb-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">{title}</h3>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
